<template>
  <div class="box-information-content">
    <a-card :bordered="false" size="small">
      <div slot="title" class="title-box">
        <label class="plate-title">
          <strong>Pick-up / Send-off</strong>
          <!-- @click="showPnrBtn" -->
          <a @click="showPnrBtn" class="handle-ref-add" style="margin-left: 5px;" ><a-icon type="plus"/></a>
          <!-- <span style="color:red;margin-left: 10px;"> *Need {{ }} air</span> -->
        </label>
      </div>
      <div>
        <div>
          <div class="agent-info">
            <a-row type="flex" :gutter="10">
              <a-col :span="5">
                <div>
                  <strong>PNR1:
                    <a-tooltip class="pnr-tooltip" placement="topLeft" :overlayStyle="{ maxWidth: '499px' }">
                      <template slot="title" >
                        <div>
                          <ul style="list-style:none;padding:0;white-space: nowrap;">
                            <li>1 UA2033V 28Aug SFOORD HK 1035A 443P</li>
                            <li>2 UA0912V 28Aug ORDKEF HK 745P 700A+1</li>
                            <li>3 UA0913L 08Sep KEFORD HK 1030A 1215P</li>
                            <li>4 UA0305L 08Sep ORDSFO HK 340P 617P</li>
                          </ul>
                        </div>
                      </template>
                      <a href="javascript:;" class="link-url">RSVAXW</a>
                    </a-tooltip>
                  </strong>
                  <span>(PAX: 1)</span>
                  <span>
                    <a-tooltip placement="topLeft"> 
                      <template slot="title">
                        By Sign
                      </template>
                        <img style="width: 14px; padding-bottom: 2px;margin-left: 3px;" src="@/assets/logo_signet.png" alt="logo">
                    </a-tooltip>
                  </span>
                </div>
              </a-col>
              <a-col :span="18">
                <span>1.MA/ANGELA YUET MING </span>
              </a-col>
              <a-col class="popcon-text" :span="1">
                <a-popconfirm
                  title="Are you sure?"
                  ok-text="Yes" 
                  cancel-text="No"
                >
                  <a class="delete" style="margin-right: 10px;"><a-icon type="delete" /></a>
                </a-popconfirm>
              </a-col>
            </a-row>
            <a-row type="flex">
              <a-col :span="2">
                <div>Pick Up</div>
                <div>Send Off</div>
              </a-col>
              <a-col :span="2">
                <div>UA0912</div>
                <div>UA0913</div>
              </a-col>
              <a-col :span="2">
                <div>08/28/2021</div>
                <div>09/08/2021</div>
              </a-col>
              <a-col :span="2">
                <div>ORD/KEF</div>
                <div>KEF/ORD</div>
              </a-col>
              <a-col :span="4">
                <div>7:45PM - 7:00AM+1</div>
                <div>10:30AM - 12:15PM</div>
              </a-col>
              <a-col :span="12">
                <div><a>Not in pick-up timeframe</a></div>
                <div><a>Not in send-off timeframe</a></div>
              </a-col>
            </a-row>
          </div>
          <!--  -->
          <div class="agent-info">
            <a-row type="flex">
              <a-col :span="5">
                <div>
                  <strong>PNR1:
                    <a-tooltip class="pnr-tooltip" placement="topLeft" :overlayStyle="{ maxWidth: '499px' }">
                      <template slot="title" >
                        <div>
                          <ul style="list-style:none;padding:0;white-space: nowrap;">
                            <li>1 UA2033V 28Aug SFOORD HK 1035A 443P</li>
                            <li>2 UA0912V 28Aug ORDKEF HK 745P 700A+1</li>
                            <li>3 UA0913L 08Sep KEFORD HK 1030A 1215P</li>
                            <li>4 UA0305L 08Sep ORDSFO HK 340P 617P</li>
                          </ul>
                        </div>
                      </template>
                      <a href="javascript:;" class="link-url">DNYRVT</a>
                    </a-tooltip>
                  </strong>
                  <span>(PAX: 1)</span>
                  <span>
                    <a-tooltip placement="topLeft"> 
                      <template slot="title">
                        By Sign
                      </template>
                        <img style="width: 14px; padding-bottom: 2px;margin-left: 3px;" src="@/assets/logo_signet.png" alt="logo">
                    </a-tooltip>
                  </span>
                </div>
              </a-col>
              <a-col :span="18">
                <span>1.MA/ANGELA YUET MING </span>
              </a-col>
              <a-col class="popcon-text" :span="1">
                <a-popconfirm
                  title="Are you sure?"
                  ok-text="Yes" 
                  cancel-text="No"
                >
                  <a class="delete" style="margin-right: 10px;"><a-icon type="delete" /></a>
                </a-popconfirm>
              </a-col>
            </a-row>
            <a-row type="flex">
              <a-col :span="2">
                <div>Pick Up</div>
                <div>Send Off</div>
              </a-col>
              <a-col :span="2">
                <div>UA0912</div>
                <div>UA0913</div>
              </a-col>
              <a-col :span="2">
                <div>08/28/2021</div>
                <div>09/08/2021</div>
              </a-col>
              <a-col :span="2">
                <div>ORD/KEF</div>
                <div>KEF/ORD</div>
              </a-col>
              <a-col :span="4">
                <div>7:45PM - 7:00AM+1</div>
                <div>10:30AM - 12:15PM</div>
              </a-col>
              <a-col :span="12">
                <div><a>Not in pick-up timeframe</a></div>
                <div><a>Not in send-off timeframe</a></div>
              </a-col>
            </a-row>
          </div>
        </div>
        <!-- pnr显示 -->
        <div v-show="isShowPnrForm">
          <div class="flex">
            <a-form :form="form" layout="inline" autocomplete="off" class="flex">
              <a-form-item label='PNR' >
                <a-input
                @change="handlePnrInput"
                  v-decorator="[
                    'pnr',
                      {
                        rules: [{ required: true, message: 'Please input the PNR' }],
                      }
                  ]"
                  />
              </a-form-item>
              <a-form-item>
                <a-radio-group v-model="value" @change="onChange">
                  <a-radio :value="1">
                    By Signet
                  </a-radio>
                  <a-radio :value="2">
                    Not by Signet
                  </a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item>
                <a-popconfirm
                  title="Are you sure?"
                  
                  ok-text="Yes" 
                  cancel-text="No"
                >
                  <a-button type="primary" style="margin-right: 8px;">Confirm</a-button>
                </a-popconfirm>
                <a-button @click="hidePnrForm">Cancel</a-button>
              </a-form-item>	
            </a-form>
          </div>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>

export default {
  name: 'BookPickMain',
  components: {
  },
  props: {
  },
  data () {
    return {
      isShowPnrForm: false,
			isShowPnrBtn: true,
      value: 1,
      pnrForm:'',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    }
  },
  mounted () {
  },
  methods: {
    // pnr添加事件
    showPnrBtn(){
      this.isShowPnrForm = true
			this.isShowPnrBtn = false
    },
    // cancel按钮
    hidePnrForm(){
			this.isShowPnrForm = false
			this.isShowPnrBtn = true
		},
    // 单选事件
    onChange(e){
      console.log('radio checked', e.target.value)
    },
    // 表单提交事件
    handlePnrInput(e){
			if(e.target.value){
				e.target.value = e.target.value.replace(/[^A-Za-z0-9]/g,'').toUpperCase()
			}
		},
    
    
  }
}
</script>
<style lang="less" scoped>
/deep/ .agent-info {
  margin-bottom: 10px;
  border-bottom: 1px #e6e6e6 solid;
  padding-bottom: 6px;
}
.popcon-text {
  text-align: end;
}
</style>